// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownColor {
    background-color: #4360AB;
    border-color: #4360AB;
}

.d-block {
    display: block;
}

.content_Fit{
        padding: calc(80px + 1.25rem) .625rem 160px;
}

.ml-1{
    margin-left:10px
}

.mright-1{
    margin-right:10px
}
.h-4{
    height: 45px !important;
}

.pagination{
    display: flex;
    justify-content: flex-start;
}

.color-red{
    color:red;
    font-weight: 600
}

.color-green{
    color:green;
    font-weight: 600
}
.title-color{
      color: #4360AB;
}
.cursor-pointer{
    cursor: pointer !important;
}
.button-color{
    background-color: #4360AB;
    color: #fff;
    border: none;
}

.button-color:hover{
    background-color: #0d6efd !important;
}

.modal-dialog {
    max-width: 550px
}
.error_msg {font-size: 12px; text-align: center; color: #ed193b;}
.page-content .react-tel-input .form-control {width: 100%;}
.descriptionBox {border: 1px solid #e2e2e2; padding: 4px 6px; min-height: 70px; color: #74788d;background-color: #f5f6f8; border-radius: 6px;}
.activeBadge {font-weight: 600; color: rgb(47, 104, 70); font-size: 13px; line-height: 1.43; background: rgb(234, 251, 231); padding: 4px 8px; border-radius: 4px;}
.inActiveBadge {font-weight: 600; color: rgb(237 25 59); font-size: 13px; line-height: 1.43; background: rgb(237, 25, 59, 0.06); padding: 4px 8px; border-radius: 4px;}
.clickableLabel {text-transform: capitalize; cursor: pointer;}
.clickableLabel:hover {text-decoration: underline; color: #5656b5}

.react-tagsinput-input {
    width: 100% !important;
}

body.modal-open {
    padding-right: 0 !important;
  }`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;QACQ,2CAA2C;AACnD;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;AACA;MACM,cAAc;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;AACJ;AACA,YAAY,eAAe,EAAE,kBAAkB,EAAE,cAAc,CAAC;AAChE,8CAA8C,WAAW,CAAC;AAC1D,iBAAiB,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,CAAC,yBAAyB,EAAE,kBAAkB,CAAC;AAC7I,cAAc,gBAAgB,EAAE,uBAAuB,EAAE,eAAe,EAAE,iBAAiB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;AAClK,gBAAgB,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;AACtK,iBAAiB,0BAA0B,EAAE,eAAe,CAAC;AAC7D,uBAAuB,0BAA0B,EAAE,cAAc;;AAEjE;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;EAC7B","sourcesContent":[".dropdownColor {\r\n    background-color: #4360AB;\r\n    border-color: #4360AB;\r\n}\r\n\r\n.d-block {\r\n    display: block;\r\n}\r\n\r\n.content_Fit{\r\n        padding: calc(80px + 1.25rem) .625rem 160px;\r\n}\r\n\r\n.ml-1{\r\n    margin-left:10px\r\n}\r\n\r\n.mright-1{\r\n    margin-right:10px\r\n}\r\n.h-4{\r\n    height: 45px !important;\r\n}\r\n\r\n.pagination{\r\n    display: flex;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.color-red{\r\n    color:red;\r\n    font-weight: 600\r\n}\r\n\r\n.color-green{\r\n    color:green;\r\n    font-weight: 600\r\n}\r\n.title-color{\r\n      color: #4360AB;\r\n}\r\n.cursor-pointer{\r\n    cursor: pointer !important;\r\n}\r\n.button-color{\r\n    background-color: #4360AB;\r\n    color: #fff;\r\n    border: none;\r\n}\r\n\r\n.button-color:hover{\r\n    background-color: #0d6efd !important;\r\n}\r\n\r\n.modal-dialog {\r\n    max-width: 550px\r\n}\r\n.error_msg {font-size: 12px; text-align: center; color: #ed193b;}\r\n.page-content .react-tel-input .form-control {width: 100%;}\r\n.descriptionBox {border: 1px solid #e2e2e2; padding: 4px 6px; min-height: 70px; color: #74788d;background-color: #f5f6f8; border-radius: 6px;}\r\n.activeBadge {font-weight: 600; color: rgb(47, 104, 70); font-size: 13px; line-height: 1.43; background: rgb(234, 251, 231); padding: 4px 8px; border-radius: 4px;}\r\n.inActiveBadge {font-weight: 600; color: rgb(237 25 59); font-size: 13px; line-height: 1.43; background: rgb(237, 25, 59, 0.06); padding: 4px 8px; border-radius: 4px;}\r\n.clickableLabel {text-transform: capitalize; cursor: pointer;}\r\n.clickableLabel:hover {text-decoration: underline; color: #5656b5}\r\n\r\n.react-tagsinput-input {\r\n    width: 100% !important;\r\n}\r\n\r\nbody.modal-open {\r\n    padding-right: 0 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
